const CLOUDFRONT = '/';

type TpImagePath = 'images' | 'icons' | 'videos';

const getImageUrl = (path: TpImagePath = 'images') => `${CLOUDFRONT}${path}/`;

export const IMAGE_SOURCE = getImageUrl();
export const ICON_SOURCE = getImageUrl('icons');
export const VIDEO_SOURCE = getImageUrl('videos');
